import React from 'react';

//import { observable, computed, action } from "mobx";
import { observer, inject } from 'mobx-react';
import Select from 'react-select';


@inject("clusterStore")
@observer
export default class ReactMultiSelectCluster extends React.Component {

    render() {

        return (
            <div className="form-field" id={"form-select-" + this.props.field.id}>
                <label
                    htmlFor={this.props.field.id}
                    className="f7 db mb2 mt3 light-silver"
                >
                    {this.props.field.label}
                </label>
                <Select {...this.props.field.bind() }
                    options={this.props.clusterStore.ClusterOptions}
                    resetValue={[]}
                    multi={true}
                />
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/components/forms/inputs/ReactMultiSelectCluster.jsx